// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { PaginationPresentationProps } from "@mcmc/MobiusOverrides/Pagination";
import { productListStyles } from "@mcmc/Overrides/Widgets/ProductList/ListCommon.styles";
import { css } from "styled-components";

export interface ResourcesListStyles {
    filterGridContainer?: GridContainerProps;
    filterGridItem?: GridItemProps;
    resourcesGridContainer?: GridContainerProps;
    resourcesGridItem?: GridItemProps;
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    pagination?: PaginationPresentationProps;
    infoCardChildren?: InjectableCss;
}

const resourcesListStyles: ResourcesListStyles = {
    filterGridContainer: {
        gap: 30,
        css: css`
            margin-top: 20px;
            margin-bottom: 20px;
            @media print {
                break-after: avoid;
            }
        `,
    },
    filterGridItem: {
        width: [12, 6, 4, 4, 3],
        css: css`
            align-items: flex-end;
            button {
                height: 35px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                width: 100%;
                            `,
                        ],
                        "max",
                    )}
            }
        `,
    },
    resourcesGridContainer: {
        gap: 30,
        css: css`
            @media print{
                break-before: avoid;
            }
        `
    },
    resourcesGridItem: {
        width: [12, 12, 6, 4, 4],
    },
    centeringWrapper: productListStyles.centeringWrapper,
    spinner: productListStyles.spinner,
    infoCardChildren: {
        css: css`
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            margin: 0 -6px;
            font-size: 12px;
            font-weight: normal;

            .tag {
                position: relative;
                margin: 0 6px;

                &:after {
                    position: absolute;
                    top: 0;
                    right: -7px;
                    display: block;
                    content: "|";
                }

                &:last-child {
                    &:after {
                        content: none;
                    }
                }
            }

            .filter-link {
                color: ${getColor("text")};

                &:hover,
                &:focus {
                    text-decoration: underline;
                }
            }
        `,
    },
    pagination: {
        cssOverrides: {
            pagination: css`
                margin-top: 20px;
            `,
        },
    },
};

export default resourcesListStyles;
